// ============================================================================
// droitsRH.js — qui entre dans le module Ressources humaines
// ============================================================================
// Décision de Pierre du 15/10/2026 : « n'autorise pas l'accès par défaut aux
// membres du CODIR (CD). Seuls DG et RH doivent y avoir accès », puis, à la
// question du pôle d'intérêt, « Fermer le pôle aussi ». Le pôle
// « Ressources humaines » n'ouvre donc plus le module : seule l'habilitation
// explicite portée par la fiche (rôle « RH ») ou la fonction de direction
// générale (rôle « DG ») y donne accès.
//
// Pourquoi une source unique : la règle était recopiée à NEUF endroits, en
// trois formulations différentes. `canAccessRH` (uxComponents) avait oublié
// le rôle « RH » lui-même — un délégué habilité RH sans pôle était refusé par
// ce chemin. Une règle d'accès recopiée dérive, et elle dérive en silence.
// Le serveur en garde un miroir (`functions/lib/droitsRH.js`) dont
// l'équivalence d'EXÉCUTION est vérifiée par `functions/test/droitsRH.test.js`.
//
// Les administrateurs d'Enio gardent leur accès : Pierre n'a pas demandé de le
// retirer, et ils sont l'exploitant du module. L'étanchéité par mutuelle reste
// garantie côté Cloud Functions (`validateCallerRHTenant`), pas ici.
// ============================================================================

export const ROLES_RH = Object.freeze(["RH", "DG"]);

export function peutAccederRH(fiche, { isAdmin = false } = {}) {
  if (isAdmin) return true;
  if (!fiche) return false;
  const roles = Array.isArray(fiche.roles) ? fiche.roles : [];
  return roles.includes("RH") || roles.includes("DG");
}
